import React from "react";
import { useNavigate } from "react-router-dom";
import { Map, List, User } from "lucide-react";

export default function BottomNav({ active }) {
  const navigate = useNavigate();

  const items = [
    { key: "map", label: "Map", icon: Map, path: "/" },
    { key: "nearby", label: "Nearby", icon: List, path: "/nearby" },
    { key: "profile", label: "Profile", icon: User, path: "/profile" },
  ];

  return (
    <nav className="bottom-nav glass-heavy" data-testid="bottom-nav">
      {items.map((item) => (
        <button
          key={item.key}
          onClick={() => navigate(item.path)}
          className={`bottom-nav-item ${active === item.key ? "active" : ""}`}
          data-testid={`nav-${item.key}`}
        >
          <item.icon className="w-5 h-5" strokeWidth={1.5} />
          <span>{item.label}</span>
        </button>
      ))}
    </nav>
  );
}
